import { render, staticRenderFns } from "./RedirectToFrame.vue?vue&type=template&id=e63d98ce&scoped=true"
import script from "./RedirectToFrame.vue?vue&type=script&lang=js"
export * from "./RedirectToFrame.vue?vue&type=script&lang=js"
import style0 from "./RedirectToFrame.vue?vue&type=style&index=0&id=e63d98ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63d98ce",
  null
  
)

export default component.exports